import { css } from '@emotion/react';

import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import type { Interface } from './base';
import { Checkbox } from './base';

const PersonalAgreementCheckbox = styled(Checkbox)(
	({ theme, isOffline = false }: { theme: Theme; isOffline?: boolean }) => {
		const {
			checkboxBackgroundColor,
			checkboxColor,
			labelColor,
			labelFontSize,
			labelLineHeight,
			labelLinkColor,
			labelFontFamily,
			checkboxBorderColor,
			onFocusBorder,
		} = isOffline ? theme.offlineChat.checkboxes.personalAgreement : theme.prechat.checkboxes.personalAgreement;
		return css`
			color: ${labelColor};
			font-family: ${labelFontFamily};
			font-size: ${labelFontSize};
			line-height: ${labelLineHeight};
			margin-right: 10px;

			& a {
				color: ${labelLinkColor};
			}

			& > span {
				background-color: ${checkboxBackgroundColor};
				border-color: ${checkboxBorderColor};
			}

			& span::after {
				border-color: ${checkboxColor};
			}
			input:focus ~ span {
				border-color: ${onFocusBorder};
			}
		`;
	}
);

const Wrapped = styled(({ className, ...checkboxProps }: Interface) => (
	<div className={className}>
		<PersonalAgreementCheckbox {...checkboxProps} />
	</div>
))(({ theme, isOffline = false }: { theme: Theme; isOffline?: boolean }) => {
	const { marginBottom, marginTop } = isOffline
		? theme.offlineChat.checkboxes.personalAgreement
		: theme.prechat.checkboxes.personalAgreement;
	return { marginBottom, marginTop, width: '100%' };
});

export { Wrapped as PersonalAgreementCheckbox };
